var _excluded = ["className"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "./css/styles.css";

/**
 * Renders a button with vendor specific styles removed
 *
 * Forwards the ref to the underlying button
 */
var BlankButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var finalClassName = "".concat(styles.button, " ").concat(className);
  // eslint-disable-next-line react/button-has-type
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: ref,
    className: finalClassName
  }, props));
});
BlankButton.displayName = 'BlankButton';
process.env.NODE_ENV !== "production" ? BlankButton.propTypes = {
  /**
   * Class name to append
   */
  className: PropTypes.string,
  /**
   * button type. See [MDN's <button> page](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type) for more details
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit'])
} : void 0;
BlankButton.defaultProps = {
  className: ''
};
export default BlankButton;